module.exports = __webpack_public_path__ + "img/jeff-panacloc.8cb0aaa2.jpg";